import React from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';
import ReactTooltip from 'react-tooltip';
import {
  DropdownToggle, DropdownMenu, DropdownItem, UncontrolledButtonDropdown,
} from 'reactstrap';
import ReactImageFallback from 'react-image-fallback';
import {
  LOGO_LARGE_BLACK, FALLBACK_ICON, staticConstants, capitalizeEveryWord, dateFormats,
} from '../../../utils';

const getProfileImage = (item) => (item && item.managerImage !== ''
  ? item.managerImage : LOGO_LARGE_BLACK);

function ManagerItem(props) {
  const {
    item, toggleRequestModal, toggleDeactivateModal, toggleEditManagerModal, toggleDeleteModal,
  } = props;
  const fetchedProfileImage = item && item.managerImage !== ''
    ? item.managerImage : LOGO_LARGE_BLACK;
  const registerDate = moment(item.createdAt).format(dateFormats.DATE_WITH_YEAR);
  return (
    <div className={`d-flex-table-row ${(item.status === staticConstants.STATUS_TYPE.DEACTIVATED || item.isDelete) ? 'disabled-row' : ''}`}>
      <div className="d-flex-table-col  d-flex-table-col-13">
        <span className="user-name-col">
          <em className="d-flex-table-col-user-img">
            <ReactImageFallback
              src={fetchedProfileImage}
              fallbackImage={FALLBACK_ICON}
              className="image-cover"
            />
          </em>
          <em
            data-tip={capitalizeEveryWord(`${item.managerFirstName} ${item.managerLastName}`)}
            data-place="bottom"
            data-background-color="#fff"
            data-text-color="#000"
            className={`user-name ${item.status === staticConstants.STATUS_TYPE.ACTIVE && 'cursor-pointer'}`}
            onClick={() => { item.status === staticConstants.STATUS_TYPE.ACTIVE && props.toggleManagerDetailModal(item, fetchedProfileImage, registerDate); }}
          >
            {capitalizeEveryWord(`${item.managerFirstName} ${item.managerLastName}`)}
          </em>
          <ReactTooltip effect="solid" />
        </span>
      </div>
      <div className="d-flex-table-col d-flex-table-col-16">
        <span
          data-tip={item.email}
          data-place="bottom"
          data-background-color="#fff"
          data-text-color="#000"
        >
          {item.email}
        </span>
        <ReactTooltip effect="solid" />
      </div>
      <div className="d-flex-table-col d-flex-table-col-11">
        <span
          className="user-name"
          data-tip={item.contactNumber}
          data-place="bottom"
          data-background-color="#fff"
          data-text-color="#000"
        >
          {item.contactNumber}
        </span>
        <ReactTooltip effect="solid" />
      </div>
      <div className="d-flex-table-col d-flex-table-col-11">
        <span
          data-tip={registerDate}
          data-place="bottom"
          data-background-color="#fff"
          data-text-color="#000"
        >
          {registerDate}
        </span>
        <ReactTooltip effect="solid" />
      </div>
      <div className="d-flex-table-col d-flex-table-col-16 col-center"><span>{item.totalArtist}</span></div>
      <div className="d-flex-table-col d-flex-table-col-13"><span>{capitalizeEveryWord(item.companyName)}</span></div>
      <div className="d-flex-table-col d-flex-table-col-11">
        { item.isDelete
          ? (
            <span className="status-text">
              {' '}
              {staticConstants.STATUS_NAME.deleted}
              {' '}
            </span>
          )
          : (
            <span
              className={`status-text ${item.status === staticConstants.STATUS_TYPE.REQUESTED && 'requested'}
          ${item.status === staticConstants.STATUS_TYPE.REJECTED && 'rejected'}`}
              onClick={() => { item.status === staticConstants.STATUS_TYPE.REQUESTED && toggleRequestModal(item); }}
            >
              {staticConstants.STATUS_NAME[item.status]}
            </span>
          )}
      </div>
      <div className="d-flex-table-col d-flex-table-col-9">
        <span className="note-icon-col">
          {item.totalOffer}
          {!item.isDelete
          && (
          <UncontrolledButtonDropdown className="action-dropdown-toggle">
            <DropdownToggle>
              <span className="table-toggle ml-auto mr-1" />
            </DropdownToggle>
            <DropdownMenu right className="dropdown-theme action-dropdown white-space-none">
              {
                (item.status === staticConstants.STATUS_TYPE.ACTIVE
                  || item.status === staticConstants.STATUS_TYPE.DEACTIVATED) && (
                    <>
                      <DropdownItem onClick={() => { toggleDeactivateModal(item); }}>
                        {item.status === staticConstants.STATUS_TYPE.DEACTIVATED
                          ? 'Activate Account' : 'Deactivate Account'}
                      </DropdownItem>
                    </>
                )
              }
              {
                item.status === staticConstants.STATUS_TYPE.REQUESTED && (
                  <>
                    <DropdownItem onClick={() => { toggleRequestModal(item); }}>Accept Request</DropdownItem>
                    <DropdownItem onClick={() => { toggleRequestModal(item); }}>Reject Request</DropdownItem>
                  </>
                )
              }
              {
                item.status === staticConstants.STATUS_TYPE.REJECTED && item.rejectReason && (
                  <>
                    <p className="reject-message">{`${item.rejectReason.preDefined} ${item.rejectReason.custom}`}</p>
                  </>
                )
              }
              {item.status === staticConstants.STATUS_TYPE.ACTIVE && (
              <>
                <DropdownItem onClick={() => { toggleEditManagerModal(item); }}>Edit Label Info</DropdownItem>
              </>
              )}
              <DropdownItem
                className={item.status === staticConstants.STATUS_TYPE.ACTIVE ? 'item-text-red' : ''}
                onClick={() => { toggleDeleteModal(item); }}
              >
                Delete account
              </DropdownItem>
            </DropdownMenu>
          </UncontrolledButtonDropdown>
          )}
        </span>
      </div>
    </div>

  );
}

ManagerItem.propTypes = {
  item: PropTypes.object.isRequired,
  toggleRequestModal: PropTypes.func.isRequired,
  toggleDeactivateModal: PropTypes.func.isRequired,
  toggleDeleteModal: PropTypes.func.isRequired,
  toggleManagerDetailModal: PropTypes.func.isRequired,
  toggleEditManagerModal: PropTypes.func.isRequired,
};

export default ManagerItem;
